import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import communities from './communities';
import floorplans from './floorplans';
import pointsOfInterest from './points-of-interest';
import quickMoveIns from './quick-move-ins';
import ui from './ui';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    communities,
    floorplans,
    pointsOfInterest,
    quickMoveIns,
    ui,
  },
});
